import HttpService from "./htttp.service";

class CompetenciesService {
  getCompetencies = async (query, cancelToken) => {
    const endpoint = "competencies";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createCompetency = async (payload) => {
    const endpoint = "competencies";
    return await HttpService.post(endpoint, payload);
  };

  removeCompetency = async (id) => {
    const endpoint = "competencies/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateCompetency = async (id, payload) => {
    const endpoint = "competencies/" + id;
    return await HttpService.put(endpoint, payload);
  };

  getNextCompetencyReferenceCode = async () => {
    const endpoint = "competencies/next";
    return await HttpService.get(endpoint);
  };
}

export default new CompetenciesService();
